import { LocationColor } from '@shared/api/graphql/generated';

/** Номер серии `--chart-series-N` из `variables.css`; Record требует серию для каждого цвета. */
const SERIES: Record<LocationColor, number> = {
  [LocationColor.Violet]: 1,
  [LocationColor.Blue]: 2,
  [LocationColor.Green]: 3,
  [LocationColor.Yellow]: 4,
  [LocationColor.Orange]: 5,
  [LocationColor.Red]: 6,
  [LocationColor.Pink]: 7,
  [LocationColor.Purple]: 8,
  [LocationColor.Cyan]: 9,
  [LocationColor.Lime]: 10,
};

const LABELS: Record<LocationColor, string> = {
  [LocationColor.Violet]: 'Фиолетовый',
  [LocationColor.Blue]: 'Синий',
  [LocationColor.Green]: 'Зелёный',
  [LocationColor.Yellow]: 'Жёлтый',
  [LocationColor.Orange]: 'Оранжевый',
  [LocationColor.Red]: 'Красный',
  [LocationColor.Pink]: 'Розовый',
  [LocationColor.Purple]: 'Пурпурный',
  [LocationColor.Cyan]: 'Бирюзовый',
  [LocationColor.Lime]: 'Салатовый',
};

export function locationColorVar(color: LocationColor): string {
  return `var(--chart-series-${SERIES[color]})`;
}

/** Палитра в порядке серий графиков: выбор цвета локации в настройках. */
export const locationColorOptions = (Object.keys(SERIES) as LocationColor[]).map((value) => ({
  value,
  label: LABELS[value],
}));

/** Код организации без локаций: первые буквы двух первых слов, у одного слова — две первые буквы. */
export function organizationCode(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const code =
    words.length > 1
      ? words
          .slice(0, 2)
          .map((word) => word.charAt(0))
          .join('')
      : (words[0] ?? '').slice(0, 2);

  return code.toUpperCase() || '?';
}
